import { Component, OnInit } from '@angular/core';
import { VueServerMessage } from '@vue/vueframework';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../shared/services/account.service';
import { UserSearchType } from '../shared/types/UserSearchType.enum';
import { User } from '../shared/types/User';
import { AppTranslationService } from '../app-translation.service';
import { RetrievalType } from '../shared/types/RetrievalType.enum';
import { AccountRecoveryUtil } from '../shared/utils/accountrecovery.utils';

@Component({
  selector: 'app-retrieve-username',
  standalone: false,
  styleUrls: [ './retrieve-username.component.css' ],
  templateUrl: './retrieve-username.component.html'
})
export class RetrieveUsernameComponent implements OnInit {
  public searchType = UserSearchType.PROFILE;
  public readonly ACCOUNT_RECOVERY_BUNDLE_NAME = 'AccountRecovery';
  public retrievalType = RetrievalType;
  public messages: VueServerMessage[] = [];
  public translations = {
    pageTitle: ''
  };
  public clientCode: string;
  public user: User = {
    clientStudentID: '',
    email: '',
    firstName: '',
    lastName: '',
    userName: ''
  };

  public constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private appTranslationService: AppTranslationService,
    private accountRecoveryUtil: AccountRecoveryUtil
  ) { }

  public ngOnInit(): void {
    this.clientCode = this.route.snapshot.params.clientCode;
    this.getTranslations();
  }

  /**
   * Returns the candidate to the login page.
   */
  public returnToLogin(): void {
    this.accountRecoveryUtil.navigateToLogin();
  }

  public viewDisplayUserName(): void {
    this.accountRecoveryUtil.navigateToDisplayUsername(this.route.snapshot.params.clientCode);
  }

  private getTranslations(): void {
    this.translations.pageTitle = this.appTranslationService.getTranslation(this.ACCOUNT_RECOVERY_BUNDLE_NAME,
      'RetrieveUsernameComponent.PageTitle');
  }
}
